/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: callerIdLookupSourcesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteLookupSource } from './api';

/**
 * Shared helpers for Caller ID Lookup Sources module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Caller ID Lookup Source in the form.
 * Pattern: /pbx/incoming-tools/callerid-lookup-sources/new?duplicate={id}
 */
export const getCallerIdLookupSourceDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/callerid-lookup-sources/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Caller ID Lookup Source id.
 */
export const navigateToCallerIdLookupSourceDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getCallerIdLookupSourceDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Caller ID Lookup Source by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteLookupSource from './api' instead
 */
export const deleteCallerIdLookupSourceById = async (id: string | number): Promise<void> => {
  await deleteLookupSource(id);
};

